import {Typography} from "@mui/material";

const ReadSidebarEmptyMessage: React.FC<{ text: string }> = ({text}) => {
    return (
        <Typography color="text.secondary" fontSize="0.85rem"
                    sx={{px: 3, py: 4, textAlign: "center"}}>
            {text}
        </Typography>
    );
};

export default ReadSidebarEmptyMessage;
